import * as React from 'react';

import styles from './spacer.module.css';

type Props = {
    mb: 2 | 4 | 8 | 12 | 16 | 24 | 32;
    children: React.ReactNode;
};

SpacerGroup.defaultProps = {
    mb: 16,
};

export function SpacerGroup(props: Props) {
    return <div className={styles[`spacer-bottom-${props.mb}`]}>{props.children}</div>;
}
